import {
  TranscriptionNoRealtimeProviderName,
  TranscriptionProviderName,
} from "@/hooks/transcriber/types";
import { getBooleanEnv } from "@/lib/utils";

export const ProductionConfig = {
  disablePremiumRestrictions: getBooleanEnv(
    "VITE_DISABLE_PREMIUM_RESTRICTIONS"
  ),
  enableMultirecording: true,
  enableAdvancedSettings: true,
  defaultTranscriptionProvider: TranscriptionNoRealtimeProviderName.OPENAI,
  transcriptionsProvidersRealtime: [TranscriptionProviderName.OPENAI],
  transcriptionsProvidersNoRealtime: [
    TranscriptionNoRealtimeProviderName.OPENAI,
  ],
} as const;

export const DevelopmentConfig = {
  disablePremiumRestrictions: getBooleanEnv(
    "VITE_DISABLE_PREMIUM_RESTRICTIONS"
  ),
  enableMultirecording: true,
  enableAdvancedSettings: true,
  defaultTranscriptionProvider:
    TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL,
  transcriptionsProvidersRealtime: [
    TranscriptionProviderName.OPENAI,
    TranscriptionProviderName.SPEECHMATIC,
    TranscriptionProviderName.DEEPGRAM,
  ],
  transcriptionsProvidersNoRealtime: [
    TranscriptionNoRealtimeProviderName.DEEPGRAM_NOVA_3_MEDICAL,
  ],
} as const;

export const AppConfig =
  import.meta.env.VITE_APP_ENVIRONMENT == "prod"
    ? ProductionConfig
    : DevelopmentConfig;
